import { createAsyncThunk } from '@reduxjs/toolkit';
import { ImageModel, ImageModelSchema } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetCateringServiceApiResponseSchema = z.object({
    data: z.object({
        documentId: z.string(),
        title: z.string(),
        description: z.any().optional().nullable(),
        image: z.object({
            url: z.string(),
        }).optional().nullable(),
    }),
});

type GetCateringServiceApiResponse
    = ApiResponse<z.infer<typeof GetCateringServiceApiResponseSchema>>;

type GetCateringServiceActionRequest = undefined

export const getCateringService = createAsyncThunk<
    GetCateringServiceApiResponse | BaseError,
    GetCateringServiceActionRequest
>(
    'CateringPageActionsGetCateringService',
    async () => apiInstance.get(
        '/catering-service',
        {
            'populate[image][fields]': 'url',
        },
        GetCateringServiceApiResponseSchema,
    ),
);

export const GetCateringServiceActionResponseMapper = {
    getImage: (
        { data }: GetCateringServiceApiResponse,
    ): ImageModel => ImageModelSchema.parse({
        url: data.data.image?.url,
    }),

    getTitle: (
        { data }: GetCateringServiceApiResponse,
    ): string => data.data.title,

    getDescription: (
        { data }: GetCateringServiceApiResponse,
    ): any => data.data.description,
};
